import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toUpperFirstLetter'
})
export class ToUpperFirstLetterPipe implements PipeTransform {

  transform(value: string): unknown {
    if (value) {
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
    }
  }

}
